// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-404-tsx" + "-" + "decac5f059c481d546f6" + ".js";
};